import React from 'react';
import { Translate } from 'react-redux-i18n';

class ButtonsUser extends React.PureComponent {
  render() {
    const { newClient, location } = this.props;
    return (
      <div className="row margin-left-0">
        <button
          type="button"
          onClick={this.props.goBack}
          className="btn btn-warning margin-right-15"
        >
          <Translate value="return" />
        </button>
        {newClient ? (
          <div>
            <button
              type="button"
              className="btn btn-dark"
              onClick={() => this.props.createUserForm(false)}
            >
              <Translate value="create" />
            </button>

          </div>
        ) : (
          <div>
            {location ? (
              <button
                type="button"
                className="btn btn-dark"
                onClick={() => this.props.createUserForm(true)}
              >
                <Translate value="save" />
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.props.updateUser}
              >
                <Translate value="update" />
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ButtonsUser;
